import { jsx as s, Fragment as h, jsxs as g } from "react/jsx-runtime";
import * as o from "react";
import { forwardRef as y } from "react";
import "./index-2hJuj4UN.js";
import { H as b } from "./Heading-BJmz5DVg.js";
function v(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function w(...e) {
  return (t) => e.forEach((r) => v(r, t));
}
var p = o.forwardRef((e, t) => {
  const { children: r, ...n } = e, i = o.Children.toArray(r), l = i.find(C);
  if (l) {
    const a = l.props.children, c = i.map((u) => u === l ? o.Children.count(a) > 1 ? o.Children.only(null) : o.isValidElement(a) ? a.props.children : null : u);
    return /* @__PURE__ */ s(f, { ...n, ref: t, children: o.isValidElement(a) ? o.cloneElement(a, void 0, c) : null });
  }
  return /* @__PURE__ */ s(f, { ...n, ref: t, children: r });
});
p.displayName = "Slot";
var f = o.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (o.isValidElement(r)) {
    const i = N(r);
    return o.cloneElement(r, {
      ...E(n, r.props),
      // @ts-ignore
      ref: t ? w(t, i) : i
    });
  }
  return o.Children.count(r) > 1 ? o.Children.only(null) : null;
});
f.displayName = "SlotClone";
var R = ({ children: e }) => /* @__PURE__ */ s(h, { children: e });
function C(e) {
  return o.isValidElement(e) && e.type === R;
}
function E(e, t) {
  const r = { ...t };
  for (const n in t) {
    const i = e[n], l = t[n];
    /^on[A-Z]/.test(n) ? i && l ? r[n] = (...c) => {
      l(...c), i(...c);
    } : i && (r[n] = i) : n === "style" ? r[n] = { ...i, ...l } : n === "className" && (r[n] = [i, l].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function N(e) {
  var n, i;
  let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var P = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], S = P.reduce((e, t) => {
  const r = o.forwardRef((n, i) => {
    const { asChild: l, ...a } = n, c = l ? p : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(c, { ...a, ref: i });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), D = "Label", m = o.forwardRef((e, t) => /* @__PURE__ */ s(
  S.label,
  {
    ...e,
    ref: t,
    onMouseDown: (r) => {
      var i;
      r.target.closest("button, input, select, textarea") || ((i = e.onMouseDown) == null || i.call(e, r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
    }
  }
));
m.displayName = D;
const V = "_required_1vo13_1", d = {
  required: V
}, W = y(function({ children: t, htmlFor: r, required: n, ...i }, l) {
  return /* @__PURE__ */ s(b, { as: "p", variant: "subhead", asChild: !0, children: /* @__PURE__ */ g(
    m,
    {
      ref: l,
      htmlFor: r,
      className: d.label,
      ...i,
      children: [
        t,
        " ",
        n && /* @__PURE__ */ s("span", { className: d.required, children: "*" })
      ]
    }
  ) });
});
export {
  W as L
};
